import React, { Fragment, useState } from 'react'
import {
  Box,
  Button,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material'

import { VasRuleConfigModal } from './VasRuleConfigModal'
import { StorageConfigModal } from './StorageConfigModal'
import { ConfigMode } from '../types'
import { Filter } from '../../../components/_WMS/FilterComponent'

interface ConfigProductModalProps {
  skuId: number
  sku: string
  externalStorage: boolean
  typeStorageId: number
  mode: ConfigMode
  setMode: React.Dispatch<React.SetStateAction<ConfigMode>>
  handleSnackbar: (message: string, success: boolean) => void
  requestProduct: (filters?: Filter[], page?: number, pageSize?: number) => void
  onClose: () => void
}

export const ConfigProductModal: React.FC<ConfigProductModalProps> = ({
  skuId,
  sku,
  externalStorage,
  typeStorageId,
  mode,
  setMode,
  handleSnackbar,
  requestProduct,
  onClose
}) => {
  const [selectedOption, setSelectedOption] = useState<ConfigMode>(null)

  const storageEnabled = typeStorageId === 3

  return (
    <Fragment>
      {mode === 'MENU' && (
        <Fragment>
          <Typography color='textSecondary'>
            Selecciona qué deseas configurar para este producto.
          </Typography>

          <RadioGroup
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value as ConfigMode)}
          >
            <Paper
              variant='outlined'
              style={{
                width: '96%',
                padding: 12,
                marginTop: 12
              }}
            >
              <FormControlLabel
                value='VAS'
                control={<Radio />}
                label={
                  <div>
                    <Typography variant='subtitle1'>VAS</Typography>
                    <Typography variant='body2'>
                      Asociar o eliminar regla VAS.
                    </Typography>
                  </div>
                }
              />
            </Paper>
            <Paper
              variant='outlined'
              style={{
                width: '96%',
                padding: 12,
                marginTop: 12,
                ...(!storageEnabled && {
                  opacity: 0.5,
                  pointerEvents: 'none'
                })
              }}
            >
              <FormControlLabel
                value='STORAGE'
                control={<Radio />}
                label={
                  <div>
                    <Typography variant='subtitle1'>
                      Almacenamiento externo
                    </Typography>
                    <Typography variant='body2'>
                      Activar o desactivar almacenamiento externo.
                    </Typography>
                    {!storageEnabled && (
                      <Typography variant='caption' color='error'>
                        Solo disponible para Marcas con tipo almacenamiento Mixto.
                      </Typography>
                    )}
                  </div>
                }
              />
            </Paper>
          </RadioGroup>

          <Box
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 8,
              marginTop: '24px'
            }}
          >
            <Button variant='outlined' onClick={onClose}>
              Cerrar
            </Button>
            <Button
              variant='contained'
              color='primary'
              disabled={!selectedOption}
              onClick={() => setMode(selectedOption!)}
            >
              Continuar
            </Button>
          </Box>
        </Fragment>
      )}

      {mode === 'VAS' && (
        <VasRuleConfigModal
          handleSnackbar={handleSnackbar}
          skuId={skuId}
          sku={sku}
          requestProduct={requestProduct}
        />
      )}

      {mode === 'STORAGE' && (
        <StorageConfigModal
          skuId={skuId}
          sku={sku}
          currentValue={externalStorage}
          setMode={setMode}
          onClose={onClose}
          handleSnackbar={handleSnackbar}
          requestProduct={requestProduct}
        />
      )}
    </Fragment>
  )
}
